import { render, staticRenderFns } from "./menuCol.vue?vue&type=template&id=520e6a7a&scoped=true&"
import script from "./menuCol.vue?vue&type=script&lang=js&"
export * from "./menuCol.vue?vue&type=script&lang=js&"
import style0 from "./menuCol.vue?vue&type=style&index=0&id=520e6a7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520e6a7a",
  null
  
)

export default component.exports